import React from 'react';
import styled from 'styled-components';

import { AlertInfo } from '@ad-scripts/presentation/components/common/alert';

const LocalSmsMmsNumbersOnlyAlert = () => (
  <StyledAlertInfo className="alert">
    <b>Local SMS/MMS numbers only:&nbsp;</b>Before activating, please make sure you have received the A2P registration
    approval from Gladly to avoid SMS/MMS filtering.
  </StyledAlertInfo>
);

const StyledAlertInfo = styled(AlertInfo)`
  line-height: ${p => p.theme.lineHeight.base};
  margin: 12px 0;
  padding: 16px;

  svg {
    position: relative;
    top: 2px;
  }
`;

export default LocalSmsMmsNumbersOnlyAlert;
